import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { Card } from "../../../../Card";
import { Header } from "../../Header";
import { Values } from "../../Values";
import { Sharing } from "../../Sharing";
import { Wait } from "../../Wait";
import styles from "./styles.module.pcss";
var cn = classNames.bind(styles);
export var Cut = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement(Card, {
    className: cn('cut', {
      'cut--dark': props.isDark,
      'cut--wait': props.isLoading || props.isError
    }),
    tagName: "div",
    withHover: true,
    "data-t-id": "CardTypes-Cut"
  }, (props.isLoading || props.isError) && /*#__PURE__*/React.createElement(Wait, {
    isError: props.isError,
    isLoading: props.isLoading,
    onError: props.onError
  }), !props.isError && !props.isLoading && /*#__PURE__*/React.createElement("a", {
    className: cn('cut__link'),
    href: props.link,
    onClick: props.onLinkClick,
    style: {
      backgroundImage: "url('".concat(props.bgImage, "')")
    }
  }, /*#__PURE__*/React.createElement(Header, {
    availableOnlyInOffice: props.availableOnlyInOffice,
    badge: props.badge,
    cardType: props.cardType,
    connectedSettings: props.connectedSettings,
    discount: props.discount,
    forEsim: props.forEsim,
    isConnected: props.isConnected,
    isDark: props.isDark,
    title: props.title,
    titleSize: "size6-r"
  }), props.packages && /*#__PURE__*/React.createElement(Values, {
    cardType: props.cardType,
    isDark: props.isDark,
    packages: props.packages
  }), props.isYandex && /*#__PURE__*/React.createElement(Sharing, {
    badgeClassName: cn('badge'),
    cardType: props.cardType,
    isLast: props.isLast
  })));
});